import React, { useState } from 'react';
import { Text, Button, Input, Header, BackButton, TagPreview, Loading, Card } from 'ui';
import { useAuth, orderTag, useTag, useCampaign, useCompany, activateSubscription } from 'api';
import { useHistory, useParams } from 'react-router-dom';
import { green, pink } from 'config/colors';
import "./index.css";


export default function CreateCampaign(props) {
  
  // Load the tag.
  
  const auth = useAuth();
  const history = useHistory();
  const companyId = auth ? auth.company.id : null;
  const company = useCompany(companyId);
  const {tagId} = useParams();
  const tag = useTag(companyId, tagId);
  const campaign = useCampaign(companyId, tag ? tag.campaignId : null);
  const [amount, setAmount] = useState(100);
  
  
  
  
  // Create a shopify order and forward into checkout process.
  
  const [ordering, setOrdering] = useState(false);
  
  async function order() {
    if(ordering) {
      return;
    }
    setOrdering(true);
    try {
      if(company.subscriptionStart > Date.now()) {
        await activateSubscription(companyId);
      }
      const url = await orderTag(companyId, tagId, amount);
      window.location.href = url;
    }
    catch(error) {
      console.log(error);
      setOrdering(false);
    }
  }
  
  
  // Render
  
  if(!tag || !campaign || !company) {
    return <Loading/>;
  }
  
  return (
    <div>
      <Header>
        <BackButton/> <Text large light style={{flex:1}}>Order Tag</Text>
      </Header>
      <div className="ordertag-wrapper">
        <div className="ordertag-left">
          <TagPreview {...tag} style={{marginBottom:24}}/>
          <Button label="Edit Design" backgroundColor="white" to={tag.type === 'design' ? 'edit' : 'upload'}/>
        </div>
        <div className="ordertag-right">
          <Card>
            <Text block large light style={{marginBottom:24}}>Summary</Text>
            <Text block small>Campaign</Text>
            <Text block large color={green} style={{marginBottom:24}}>{campaign.name}</Text>
            <Text block small>Tag Details</Text>
            <Text block large color={pink} style={{marginBottom:24}}>{tag.variant.title}</Text>
            <Text block small>Type Qty</Text>
            <Input 
              large
              value={amount} 
              onChange={setAmount}
              style={{width:80, marginBottom:24}}
            />
            <Text block small light style={{marginBottom:32}}>Tax and Shipping NOT Included</Text>
            <div style={{marginBottom:24}}>
              <Button onClick={order} label={ordering ? "Loading..." : "Place Order"} small white backgroundColor={pink}/>
              <Button onClick={() => history.goBack()} label="Cancel" small/>
            </div>
            
            <Text block small light style={{marginBottom:24}}>
              <strong>Note</strong> this order will be processed using shopify.
              You will be directed to shopify to fill out details and complete 
              your order.
            </Text>
            
            {company.subscriptionStart > Date.now() && 
              <Text block small light style={{marginBottom:24}}>
                Placing this order will end your 30 day trial
                and immediately activate your account.
              </Text>
            }
          </Card>
        </div>
      </div>
    </div>
  );
}